import React                from "react";
import {
    useNavigate,
    useOutletContext
}                           from 'react-router-dom';
import { IOutletContext }   from "ui/components/Dashboard";
import { RequireAuth }      from "auth/AuthProvider";
import ClassFlow            from "ui/components/classes-components/ClassFlow";

// Onboarding class setup (new teacher). Same flow component as the dashboard modal,
// rendered full-page over the empty background — Create class → Add students → Review.
export default function CreateClass() {
    const navigate = useNavigate();
    const {
        setBgcolor,
        setTopBarColorDark,
        setTopBarColorLight
    } = useOutletContext<IOutletContext>();
    React.useEffect(() => {
        setBgcolor('secondary');
        setTopBarColorLight("background.default");
        setTopBarColorDark("background.paper");
    }, [setBgcolor, setTopBarColorDark, setTopBarColorLight]);
    return (
        <RequireAuth>
            <ClassFlow
                open
                variant="page"
                initialStep="create"
                onClose={() => navigate('/classes')}
                onFinish={(classId) => navigate(`/classes/${classId}`)}
            />
        </RequireAuth>
    );
}
